// extracted by mini-css-extract-plugin
module.exports = {"pageHero":"styles_pageHero__Sgzte","textContainer":"styles_textContainer__X3XB2","text":"styles_text__R1wq8","imageContainer":"styles_imageContainer__e0sna"};